/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description DatePicker
 */
import { DatePicker as AntdDatePicker, DatePickerProps } from 'antd';

import dateParser from 'lib/dateParser';
import { MONTH_DATE_YEAR_SLASH_FORMAT } from '@veritable/common/constants';

export interface IProps extends Omit<DatePickerProps, 'value' | 'onChange'> {
	value: string | null;
	placeholder?: string;
	allowClear?: boolean | { clearIcon: React.ReactNode };
	inputDateFormat?: string | 'utc';
	displayDateFormat?: string | string[] | 'utc';
	disabled?: boolean;
	suffixIcon?: React.ReactNode;
	onChange: (value: string | null) => void;
	disabledDate?: (date: IDate) => boolean;
}

/**
 * Date Picker
 * @param {IProps} props props
 * @returns {React.FC} DatePicker
 */
const DatePicker: React.FC<IProps> = ({
	value,
	onChange,
	placeholder,
	allowClear,
	disabledDate,
	disabled,
	inputDateFormat = MONTH_DATE_YEAR_SLASH_FORMAT,
	displayDateFormat = MONTH_DATE_YEAR_SLASH_FORMAT,
	suffixIcon,
	...restProps
}) => {
	/**
	 * return DatePicker
	 */
	return (
		<AntdDatePicker
			{...restProps}
			format={displayDateFormat}
			style={{ width: '100%' }}
			value={value ? dateParser(value, inputDateFormat) : null}
			onChange={(obj) => onChange(obj ? dateParser(obj).format(inputDateFormat) : null)}
			disabledDate={disabledDate}
			placeholder={placeholder}
			allowClear={allowClear}
			disabled={disabled}
			{...(suffixIcon && { suffixIcon })}
		/>
	);
};

export default DatePicker;
